export default "__VITE_ASSET__27a33128__"